import React from 'react';
import { UserUIProvider } from './UserUIContext';
import { Route } from 'react-router-dom';
import UserCard from './UserCard';

import UserEditDialog from './user-edit-dialog/UserEditDialog';
import { PrivateRoute } from "../../../../PrivateRoute";
import { BlockOrg, RoleChecker } from '../../../../RoleChecker';

export function UserPage({ history }) {

    const userUIEvents = {
        newUserButtonClick: () => {
            history.push('/access/user/new');
        },
        openEditUserPage: (id) => {
            history.push(`/access/user/${id}/edit`);
        },
    };

    return (
        <UserUIProvider userUIEvents={userUIEvents}>
            <PrivateRoute role={BlockOrg() && RoleChecker('Create', 'user')} component={UserEditDialog}
                path="/access/user/new" />
            <PrivateRoute role={RoleChecker('Edit', 'user')} component={UserEditDialog}
                path="/access/user/:id/edit" />

            <Route path="/access/user/new">
                {({ history, match }) => (
                    <UserEditDialog
                        show={match != null}
                        onHide={() => {
                            history.push('/access/user');
                        }}
                    />
                )}
            </Route>

            <Route path="/access/user/:id/edit">
                {({ history, match }) => (
                    <UserEditDialog
                        show={match != null}
                        id={match && match.params.id}
                        onHide={() => {
                            history.push('/access/user');
                        }}
                    />
                )}
            </Route>

            <UserCard />

        </UserUIProvider>
    );
}
